import { render } from "./BackNavigationItem.vue?vue&type=template&id=82cf6ac8&scoped=true"
import script from "./BackNavigationItem.vue?vue&type=script&lang=js"
export * from "./BackNavigationItem.vue?vue&type=script&lang=js"

import "./BackNavigationItem.vue?vue&type=style&index=0&id=82cf6ac8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cf6ac8"]])

export default __exports__